export default "__VITE_ASSET__BEjy3fXQ__"